import React from "react";
import ToggleSwitch from "../../elements/ToggleSwitch/ToggleSwitch";
import { t } from "i18next";

const ToggleContainer = ({ isContract, onContractToggle }) => {
    return (
        <div className="flex items-center justify-between py-1">
            <label className="text-[14px] font-medium text-[#222222]">{t('negotiable')}</label>
            <ToggleSwitch initialValue={isContract} onToggle={onContractToggle} />
        </div>
    );
};

export default ToggleContainer;
